import { NgModule } from '@angular/core';

import { BookingsRequestSendEmailComponent } from './bookings.request.send-email.component';
import { BookingsRequestSendSmsComponent }   from './bookings.request.send-sms.component';
import { SharedModule }                      from '../shared/shared.module';

@NgModule({
  declarations: [
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent
  ],
  entryComponents: [
    BookingsRequestSendEmailComponent,
    BookingsRequestSendSmsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class BookingsModule {}
